type Segmenter = { segment(t: string): Iterable<{ segment: string }> };
type SegmenterCtor = new (locale?: string, o?: { granularity: "grapheme" }) => Segmenter;

let cached: Segmenter | null | undefined;

/** One grapheme Segmenter for the page (built on first use); null where Intl.Segmenter is missing. */
function segmenter(): Segmenter | null {
  const Seg = (Intl as { Segmenter?: SegmenterCtor }).Segmenter;
  if (!Seg) return null;
  return (cached ??= new Seg(undefined, { granularity: "grapheme" }));
}

/** Whole user-perceived characters (emoji with joiners, flags, skin tones stay in one piece); code points where Intl.Segmenter is missing. */
function* graphemes(text: string): Generator<string> {
  const seg = segmenter();
  if (!seg) yield* Array.from(text);
  else for (const s of seg.segment(text)) yield s.segment;
}

/**
 * The longest start of `text` that is at most `max` code points and ends between two characters:
 * an emoji that would be cut in half is dropped whole. `max` counts code points, the unit server limits use.
 */
export function graphemeSlice(text: string, max: number): string {
  let used = 0;
  let out = "";
  for (const g of graphemes(text)) {
    used += Array.from(g).length;
    if (used > max) break;
    out += g;
  }
  return out;
}

/** The first whole character of `text` ("" when empty or missing), for avatar initials; segments only as far as that. */
export function firstGrapheme(text: string | null | undefined): string {
  for (const g of graphemes(text ?? "")) return g;
  return "";
}
